import { render } from "./LogoList.vue?vue&type=template&id=0014b24c"
import script from "./LogoList.vue?vue&type=script&lang=js"
export * from "./LogoList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__